import { render, staticRenderFns } from "./oldNewDetail.vue?vue&type=template&id=79a5d838&scoped=true&"
import script from "./oldNewDetail.vue?vue&type=script&lang=js&"
export * from "./oldNewDetail.vue?vue&type=script&lang=js&"
import style0 from "./oldNewDetail.vue?vue&type=style&index=0&id=79a5d838&prod&lang=scss&scoped=true&"
import style1 from "./oldNewDetail.vue?vue&type=style&index=1&id=79a5d838&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a5d838",
  null
  
)

export default component.exports